export const getLogger = ({ trace, error }) => ({
  logTrace: trace,
  logError: error,
});
